/* unplugin-vue-components disabled */import script from "./CategoryFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFormModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFormModal.vue?vue&type=style&index=0&id=7607cd2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7607cd2a"]])

export default __exports__